import React, { Component } from "react";
import { Table, Button, Col, Tooltip, Row, Modal, DatePicker } from "antd";
import axios from "axios";
import "./Pages.css";
import ComissaoVendasPrintModal from "../relatorios/ComissaoVendasPrintModal";
import PessoaFrame from '../components/PessoaFrame';
import moment from "moment-timezone";
import numeral from "numeral";
import { getUsuario } from "../utils/LoginManager";
import { maskDate } from "../utils/Masker";
import ComissaoVendaForm from '../components/ComissaoVendaForm';
import Colors from '../utils/Colors';

const dateFormat = 'DD/MM/YYYY'
const { RangePicker } = DatePicker;
const { Column } = Table;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,

    totalComissoes: 0,
    formVisivel: false,
    vendedor: '',

    filtros: {
      tipoTela: 'CV',
      buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaPessoa: { key: '', },
    }

  };

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({
      usuario,
    }, this.getListaRegistros);
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }


  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true, totalComissoes: 0 });
    const { pagina, limite } = this.state;

    const { buscaDataIni, buscaDataFim, buscaPessoa } = this.state.filtros;

    if ((buscaDataIni) && (buscaDataFim)) {

      let dataIni = '';
      if ((buscaDataIni) && (buscaDataIni !== undefined)) {
        dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }
      let dataFim = '';
      if ((buscaDataFim) && (buscaDataFim !== undefined)) {
        dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }

      axios
        .get('/vendas/listaComissoesVendedores', {
          params: {
            page: pagina,
            limite: limite,
            dataIni,
            dataFim,
            tipo: '',
          }
        })
        .then(response => {

          this.setState({
            listaRegistros: response.data.dados,
            carregando: false,
            totalComissoes: response.data.vlrTotal,
          });

        })
        .catch(erro => {
          console.warn(erro);
          this.setState({
            carregando: false,
          });
        });
    } else {
      this.setState({
        listaRegistros: [],
        carregando: false,
      });
    }
  };

  onVisualizarClick = (registro) => {
    this.setState({
      formVisivel: true,
      registroSelecionado: {
        vendedor: registro.usu_idf,
        totalComissoes: parseFloat(registro.vlrTotal * (registro.ue_perc_comissao / 100)),
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
      }
    })
  };

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }



  onChangePessoa = event => {
    const { filtros } = this.state;
    filtros['buscaPessoa'] = event.buscaPessoa;
    this.setState(
      event,
      this.getListaRegistros
    );
  }


  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { filtros } = this.state;
    filtros[id] = value;
    this.setState({
      [id]: value
    },
      this.getListaRegistros
    );
  };

  onChangePeriodo = event => {
    const { filtros } = this.state;
    if (event[0]) {
      filtros.buscaDataIni = moment(event[0]._d).format('DD/MM/YYYY');
      filtros.buscaDataFim = moment(event[1]._d).format('DD/MM/YYYY');
    } else {
      filtros.buscaDataIni = moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD/MM/YYYY');
      filtros.buscaDataFim = moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY');
    }
    this.setState({
      filtros
    },
      this.getListaRegistros
    );
  };





  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      return (
        <span></span>
      )
    }
  }


  renderAcoes = (text, registro) => {
    return (
      <Tooltip title="Detalhes da Comissão">
        <Button type="ghost" size="small" onClick={() => this.onVisualizarClick(registro)} icon="eye-o" />
      </Tooltip>
    );
  };

  renderValor = (vlr) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };

  renderValorComissao = (vlr, registro) => {
    return (
      <span> {numeral(parseFloat(registro.vlrTotal * (registro.ue_perc_comissao / 100))).format('0,000.00')} </span>
    );
  };



  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, registroSelecionado, formVisivel,
      vendedor, carregando, filtros, total, pagina, limite, } = this.state;
    const { buscaDataIni, buscaDataFim, buscaPessoa } = this.state.filtros;

    // console.log('ComissaoVendasPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <span className="tituloPage">Comissões dos Vendedores</span>
        <div className="divider-page" />

        <Row>
          <div className="pageFiltro" style={{ height: 20 }}>
            <Col xs={24} >

              <Row style={{}}>
                <Col xs={6} style={{ marginRight: 10 }}>
                  <span>Período</span>
                  <RangePicker
                    style={{ width: "100%" }}
                    masker={maskDate}
                    value={[moment(buscaDataIni, dateFormat), moment(buscaDataFim, dateFormat)]}
                    format={dateFormat}
                    allowClear={false}
                    onChange={this.onChangePeriodo}
                  />
                </Col>

                {/* <Col xs={6} style={{ width: 420, marginTop: -5, marginLeft: -35 }}>
                  <PessoaFrame
                    label="Cliente"
                    id="buscaPessoa"
                    value={buscaPessoa}
                    width={"100%"}
                    tipo="C"
                    onChange={this.onChangePessoa}
                  />
                </Col> */}

                <Col xs={2} style={{ width: 110, marginTop: 20 }}>
                  <ComissaoVendasPrintModal
                    filtros={filtros}
                    listaRegistros={listaRegistros}
                    totalComissoes={this.state.totalComissoes}
                    periodo={this.state.filtros.buscaDataIni + ' a ' + this.state.filtros.buscaDataFim}
                  />
                </Col>


                <Col xs={24} md={6} style={{ height: 65, padding: 5, marginTop: 0 }}>
                  <Col xs={24} md={24} style={{ height: 65, padding: 5 }}>
                    <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                      <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                        <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                          Total Comissões
                        </span>
                      </Row>
                      <Row style={{ textAlign: "center" }}>
                        <Row style={{ marginTop: -5 }}>
                          <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.totalComissoes)}</span>
                        </Row>
                      </Row>
                    </div>
                  </Col>
                </Col>

                {/* <Col xs={24} sm={4} style={{ background: Colors.background, padding: 5, marginTop: 10, marginLeft: 20 }}>
                  <Col xs={24} sm={24} style={{ marginRight: 5, textAlign: "center", background: "white" }} >
                    <Row><span style={{ fontWeight: "bold" }}>Total Comissões</span></Row>
                    <Row><span>R$ {this.renderValor(this.state.totalComissoes)}</span></Row>
                  </Col>
                </Col> */}

                <ComissaoVendaForm
                  visivel={formVisivel}
                  onCancelarClick={this.onCancelarClick}
                  registroSelecionado={registroSelecionado}
                  periodo={this.state.filtros.buscaDataIni + ' a ' + this.state.filtros.buscaDataFim}
                  tipo=''
                />

              </Row>

            </Col>

          </div>
        </Row>

        <Row>
          <div style={{ marginTop: 10 }}>
            <Table
              pagination={false}
              onChange={this.onTabelaChange}
              loading={{
                spinning: carregando,
                tip: 'Carregando. Aguarde...',
                size: "large"
              }}
              dataSource={listaRegistros}
              rowKey={(registro => registro.usu_idf)}
            >
              <Column
                key="usu_nome"
                dataIndex="usu_nome"
                title="Nome Vendedor"
                width={200}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="ue_perc_comissao"
                dataIndex="ue_perc_comissao"
                title="% Comissão"
                render={this.renderValor}
                width={80}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="vlrTotal"
                dataIndex="vlrTotal"
                title="Valor Total"
                render={this.renderValor}
                width={80}
                align="right"
                className="listaCadastro"
              />
              <Column
                key=""
                dataIndex=""
                title="Valor Comissão"
                render={this.renderValorComissao}
                width={80}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="acoes"
                title=""
                render={this.renderAcoes}
                width={40}
                align="center"
                className="listaCadastro"
              />
            </Table>
          </div>
        </Row>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/ComissaoVendasPage.js